import { Slot } from '@radix-ui/react-slot'
import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

const marketingButtonVariants = cva(
	'inline-flex items-center justify-center rounded-full font-sans font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 disabled:pointer-events-none disabled:opacity-50 hover:scale-[1.01] active:scale-[0.98]',
	{
		variants: {
			variant: {
				primary:
					'bg-neutral-900 text-white hover:bg-neutral-800 ',
				secondary:
					'bg-white text-neutral-900 border border-neutral-200 hover:bg-neutral-50 hover:border-neutral-300 ',
				outline:
					'border border-neutral-200 text-neutral-600 hover:text-neutral-900 hover:border-neutral-900 hover:bg-transparent',
				ghost: 'text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100/50',
				inverted: 'bg-white text-neutral-950 hover:bg-neutral-50 ',
				'inverted-outline': 'border border-white/20 text-white hover:bg-white/10 hover:border-white/40',
			},
			size: {
				default: 'h-12 px-8 text-base',
				sm: 'h-9 px-5 text-sm',
				lg: 'h-14 px-10 text-lg',
				icon: 'h-10 w-10',
			},
		},
		defaultVariants: {
			variant: 'primary',
			size: 'default',
		},
	},
)

export interface MarketingButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof marketingButtonVariants> {
	asChild?: boolean
}

export const MarketingButton = React.forwardRef<HTMLButtonElement, MarketingButtonProps>(
	({ className, variant, size, asChild = false, ...props }, ref) => {
		const Comp = asChild ? Slot : 'button'
		return <Comp className={cn(marketingButtonVariants({ variant, size, className }))} ref={ref} {...props} />
	},
)
MarketingButton.displayName = 'MarketingButton'
